import { render } from "./ComparisonProducts.vue?vue&type=template&id=5165cd37&scoped=true"
import script from "./ComparisonProducts.vue?vue&type=script&lang=js"
export * from "./ComparisonProducts.vue?vue&type=script&lang=js"

import "./ComparisonProducts.vue?vue&type=style&index=0&id=5165cd37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5165cd37"]])

export default __exports__